import { isNil } from 'ramda';

export class Capacity {
  readonly unit: 'VA' | 'kVA' = 'VA' as const;
  private value?: number | null;
  private constructor(value?: number | null, unit: 'VA' | 'kVA' = 'VA') {
    this.value = value;
    this.unit = unit;
  }

  static from(value?: number | null) {
    return new Capacity(value);
  }

  toKiloVoltAmpere() {
    if (isNil(this.value)) return this;
    return new Capacity(this.value / 1000, 'kVA');
  }

  toString() {
    if (isNil(this.value)) {
      return 'N/A';
    }
    return `${this.value.toFixed(2)} ${this.unit}`;
  }
}
